
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ShelvableBackend } from '../../services/ShelvableBackend/ShelvableBackend';
import { GoogleData } from '../../services/GoogleData/GoogleData';
import { Book } from '../../services/GoogleData/Book';

import { StateService, StateParams } from '@uirouter/angular';

import { Observable, Subject, BehaviorSubject } from 'rxjs';

@Component({
    selector: 'exploreAuthor',
    templateUrl: './explore-author.html',
    styleUrls: ['./explore-author.css', './explore-author.mobile.css'],
    encapsulation: ViewEncapsulation.None
})
export class ExploreAuthorComponent {
    books:Book[] = [];
    loadingBooks:boolean = false;
    maxBooks:number = Number.MAX_SAFE_INTEGER;
    loadingQuery:boolean = true;
    knowledge:{
        name:string, 
        image?:{
            contentUrl:string
        },
        detailedDescription?:{
            url?:string,
            articleBody:string
        }
    } = null;
    queryExists:boolean = true;
    bookQuery:string;
    bannerDismissed:boolean = false;
    isLoggedIn:Observable<boolean>;

    async getGoogleBooks() {
        if (this.loadingBooks || !this.knowledge || !this.bookQuery) {
            return;
        }
            
        if (this.books.length >= this.maxBooks) {
            return;
        }
        this.loadingBooks = true;
        var booksList = await this.googleData.getGoogleBooksList('author:' + this.bookQuery, this.books.length, 40);
        this.maxBooks = booksList.totalItems;
        this.books = booksList.books;
        this.loadingBooks = false;
    }

    goToAuthor(url) {
        this.stateService.go('exploreAuthor', {query: url});
    };

    authorSearch:Subject<string> = new BehaviorSubject<string>('');
    clearSearch() {
        this.authorSearch.next('');
    }

    typeaheadStatus:{
        failed:boolean,
        searching:boolean
    } = {
        failed: false,
        searching: false
    };
    getAuthors = (text:Observable<string>) => 
        text
        .debounceTime(300)
        .distinctUntilChanged()
        .do(() => this.typeaheadStatus.searching = true)
        .switchMap(term =>
            this.shelvableBackend.getAuthors(term)
            .do(() => this.typeaheadStatus.failed = false)
            .map((values) => values.filter((author) => author.url !== this.stateService.params.query))
            .catch(() => {
                this.typeaheadStatus.failed = true;
                return Observable.of([]);
            }))
        .do(() => this.typeaheadStatus.searching = false)
        .merge(new Observable(() => () => this.typeaheadStatus.searching = false));

    getName = (result: {name:string, url:string}) => result.name;

    constructor(private shelvableBackend:ShelvableBackend, 
                private googleData:GoogleData, 
                private stateService:StateService) {
        this.getData();
        this.isLoggedIn = shelvableBackend.loggedInUserObs.isLoggedIn;
    }

    async getData() {
        try {
            var author = await this.shelvableBackend.getExploreAuthorByQuery(this.stateService.params.query);
            if (author.id) {
                var knowledgeResult = await this.googleData.getGoogleKnowledgeGraph(author.id);
    
                this.loadingQuery = false;
                if (knowledgeResult && knowledgeResult.itemListElement && knowledgeResult.itemListElement.length && knowledgeResult.itemListElement.length > 0 && knowledgeResult.itemListElement[0].result) {
                    this.knowledge = knowledgeResult.itemListElement[0].result;
                } else {
                    this.knowledge = {
                        name: author.name
                    };
                }
                
                this.bookQuery = author.query || author.name;
                this.getGoogleBooks();
            } else {
                this.knowledge = {
                    name: author.name
                };
                
                this.bookQuery = author.name;
                this.getGoogleBooks();
            }
        } catch (err) {
            console.error(err);
            this.queryExists = false;
        }
    }
}



// WEBPACK FOOTER //
// ./web/static/components/explore-author/explore-author.ts